import { EventType, Features, SourcePages } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface FooterTapLanguageChangeEventInfo {
  locale: string;
  pathName: SourcePages;
}

const event = ({ locale, pathName }: FooterTapLanguageChangeEventInfo): EventData => {
  return {
    event_type: EventType.engagement,
    source_page: pathName,
    feature: Features.footerNav,
    engagement_type: locale === 'en' ? 'language_english_tap' : 'language_spanish_tap',
  };
};

export default event;
